import React, { useState } from 'react'

function Header({setSerie}) {
    const [search, setSearch] = useState('')
    const [query, setQuery] = useState('')

    const inputHandler = (e) => {
        setSearch(e.target.value)
    }
    const submitHandler = (e) => {
        e.preventDefault()
        const text=search.replace(' ','+')
        setQuery(text)
        setSerie(text)
        setSearch('')
    }
    return (
        <header>
            <h1 className='logo font-effect-anaglyph'>seriesinfo</h1>
            <form onSubmit={(e)=>submitHandler(e)}>
                <input 
                type="text" 
                value={search} 
                onChange={(e) => inputHandler(e)}
                placeholder='search'
                />
            </form>
        </header>
    )
}

export default Header
